import { Alert } from '@hakimo-ui/shared/ui-base';

export function getAlert(message: string) {
  return (
    <div className="p-6">
      <Alert>{message}</Alert>
    </div>
  );
}
